import { jsx as _jsx } from "react/jsx-runtime";
import Edit16 from '@carbon/icons-react/es/edit/16';
import { Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
const MenuItem = styled(Menu.Item)`
  span {
    flex: 1;
  }
`;
const BaseEdit = (params)=>{
    const { icon = /*#__PURE__*/ _jsx(Edit16, {}), children } = params;
    return /*#__PURE__*/ _jsx(MenuItem, {
        icon: icon,
        ...params,
        children: children || /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "edit"
        })
    });
};
export const Edit = withHideIfNotAllowed(BaseEdit);
